var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footnotes"},_vm._l((_vm.footnotes.list()),function(footnote){return _c('div',{key:`footnote-${footnote.prefix}-${footnote.translationKey}`,staticClass:"box infomessage footnote"},[_vm._v(" ("),_c('small',[_vm._v(_vm._s(footnote.symbol))]),_vm._v(") "+_vm._s(_vm.$t(footnote.translationKey))+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }